<template>
  <span class="scaling-svg-container">
    <svg xmlns="http://www.w3.org/2000/svg" width="16.3" height="16.3" viewBox="0 0 16.3 16.3" class="scaling-svg">
      <g id="Icon_time" transform="translate(-1.612 -1.612)">
        <g id="Icon_time-2" data-name="Icon_time" transform="translate(2 2)">
          <path
            id="Path"
            d="M3.1.776a.776.776,0,1,1,1.552,0v3.1a.776.776,0,0,1-.776.776H.776a.776.776,0,1,1,0-1.552H3.1Z"
            transform="translate(4.657 4.657)"
            stroke="currentColor"
            stroke-width="0.3"
          />
          <path
            id="Shape"
            d="M8,16a8,8,0,1,1,8-8A8.009,8.009,0,0,1,8,16ZM8,1.6A6.4,6.4,0,1,0,14.4,8,6.407,6.407,0,0,0,8,1.6Z"
            transform="translate(-0.238 -0.238)"
            stroke="currentColor"
            stroke-width="0.3"
          />
        </g>
      </g>
    </svg>
  </span>
</template>

<script lang="ts">
import "reflect-metadata";
import { Component, Vue } from "vue-property-decorator";

@Component
export default class HistoryIcon extends Vue {}
</script>

<style>
</style>
